/** Response of a single file upload */

/** Base type for a single response of a multi file upload */

/** Successful response of an item in a multi file upload */

/** Failed response of an item in a multi file upload */

/** Canceled response of an item in a multi file upload */

/** Possible responses of an item in a multi file upload */

/** Response of a multi file upload job */

/** Possible file upload responses */

/**
 * Used to determine the usage of the file upload by upload manager
 */
export let UploadElementType = /*#__PURE__*/function (UploadElementType) {
  /** Default usage to upload files without specifying a project */
  UploadElementType["default"] = "default";
  /** Upload files to a project */
  UploadElementType["project"] = "project";
  /** Upload files for a project annotation */
  UploadElementType["annotation"] = "annotation";
  /** Upload files to a group */
  UploadElementType["group"] = "group";
  return UploadElementType;
}({});

/** Metadata of an existing file that may by re-used by CoreFileUploader. */

/** Map from hash(filename, size) to file attributes, to identify if it's the same file. */

/** Base context for a file upload task */

/** Default context for a file upload task */

/** Base context for a file upload task targeted to an specific project */

/** Context for a file upload task targeted to an specific project */

/** Context for a file upload task targeted to an specific group */

/** Context for a file upload task targeted to an specific annotation of a project */

/** A task to track the upload of a file */

/** Necessary properties to upload a file */

/**
 * Extended finalizer callback, with access to all required properties to populate CaptureTreeEntity.pointClouds.
 * See @faro-lotv/service-wires > FinalizerCallback.
 */

/** Necessary properties to upload multiple file */

/** All the params to validate file and to add failed upload task */

/** All the params to add a failed task in store while validate file */